// Display-name helpers. Mirrors services/identity.py on the backend.
// A member is "pending setup" until they save a real name: display_name is
// blank, equals their email, or looks like an email.

export const PENDING_LABEL = 'Pending setup'

const EMAIL_RE = /^\S+@\S+\.\S+$/

export interface NamedMember {
  display_name?: string | null
  email?: string | null
  user_id?: string
  is_pending?: boolean
}

export function isPlaceholderName(name?: string | null, email?: string | null): boolean {
  const cleaned = (name || '').trim()
  if (!cleaned) return true
  if (email && cleaned.toLowerCase() === email.trim().toLowerCase()) return true
  return EMAIL_RE.test(cleaned)
}

// The API already returns display_name as "Pending setup (email)" with
// is_pending=true; the other checks keep this right against an older API.
export function isPendingMember(m: NamedMember): boolean {
  if (m.is_pending) return true
  const name = (m.display_name || '').trim()
  return name.startsWith(PENDING_LABEL) || isPlaceholderName(name, m.email)
}

export function memberName(m: NamedMember): string {
  if (!isPendingMember(m)) return (m.display_name || '').trim()
  const email = (m.email || '').trim()
  return email ? `${PENDING_LABEL} (${email})` : PENDING_LABEL
}

// Avatar initials: two letters from a real name, else the email's first letter.
export function memberInitials(m: NamedMember): string {
  if (isPendingMember(m)) return (m.email?.trim()?.[0] || '?').toUpperCase()
  const p = (m.display_name || '').trim().split(/\s+/)
  return (p.length > 1 ? p[0][0] + p[p.length - 1][0] : p[0].slice(0, 2)).toUpperCase()
}
